import React, {useEffect, useState} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from 'prop-types';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import Select from "@material-ui/core/Select";
import isEmail from "validator/lib/isEmail";
import InputAdornment from "@material-ui/core/InputAdornment";

const initialUser = {
    name: '',
    surname: '',
    email: '',
    branch: '',
    contact_number: '',
}

const AddUserDialog = props => {
    const [user, setUser] = useState(initialUser)
    const {addUserHandler} = props
    const [open, setOpen] = React.useState(false)
    const [addButton, setAddButton] = useState(false)

    const [nameError, setNameError] = useState(false);
    const [nameErrorMsg, setNameErrorMsg] = useState('');
    const [branchError, setBranchError] = useState(false);
    const [branchErrorMsg, setBranchErrorMsg] = useState('');
    const [lastNameError, setLastNameError] = useState(false);
    const [lastNameErrorMsg, setLastNameErrorMsg] = useState('');
    const [emailError, setEmailError] = useState(false);
    const [emailErrorMsg, setEmailErrorMsg] = useState('');
    const [contactError, setContactError] = useState(false);
    const [contactErrorMsg, setContactErrorMsg] = useState('');
    const [error, setError] = useState(false);


    const [switchState, setSwitchState] = React.useState({
        addMultiple: false,
    })

    const handleSwitchChange = name => event => {
        setSwitchState({...switchState, [name]: event.target.checked})
    }

    const resetSwitch = () => {
        setSwitchState({ addMultiple: false })
    }

    const handleClickOpen = () => {
        // console.log("emp id:", props.data.id);
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
        resetSwitch()
    }

    const handleAdd = event => {
        //if any field is empty don't submit
        if (user.name === '') {
            setNameError(true)
            setNameErrorMsg('Field is required')
            setError(true);
            return;
        }
        if (user.surname === '') {
            setLastNameError(true)
            setLastNameErrorMsg('Field is required')
            setError(true);
            return;
        }
        if (user.branch === '') {
            setBranchError(true)
            setBranchErrorMsg('Field is required')
            setError(true);
            return;
        }
        if (user.email === '') {
            setEmailError(true)
            setEmailErrorMsg('Field is required')
            setError(true);
            return;
        }
        if (!isEmail(user.email)) {
            setEmailError(true)
            setEmailErrorMsg('Email not valid')
            setError(true);
            return;
        }
        if (user.contact_number === '') {
            setContactError(true)
            setContactErrorMsg('Field is required')
            setError(true);
            return;
        }
        if (user.contact_number.length < 9) {
            setContactError(true)
            setContactErrorMsg('Mobile number must be a 9 digit number')
            return;
        }

        //reset error messages
        setError(false)
        setEmailError(false);
        setNameError(false);
        setLastNameError(false);
        setContactError(false);
        setBranchError(false);

        addUserHandler(user)
        setUser(initialUser)
        switchState.addMultiple ? setOpen(true) : setOpen(false)
    }

    const handleChange = name => ({target: {value}}) => {
        //validate on change
        if (name === 'name' && value === '') {
            setNameError(true)
            setNameErrorMsg('Field is required')
        } else {
            setNameError(false);
            setNameErrorMsg('')
        }
        if (name === 'branch' && value === '') {
            setBranchErrorMsg('Field is required')
        } else {
            setBranchErrorMsg('')
        }
        if (name === 'email' && value === '') {
            setEmailError(true)
            setEmailErrorMsg('Field is required')
        } else {
            setEmailError(false)
            setEmailErrorMsg('')
        }
        if (name === 'surname' && value === '') {
            setLastNameError(true)
            setLastNameErrorMsg('Field is required')
        } else {
            setLastNameError(false);
            setLastNameErrorMsg('')
        }

        if (name === 'email' && isEmail(value) === false) {
            console.log(emailError)
            setEmailError(true)
            setEmailErrorMsg('Email not valid')
        } else {
            setEmailError(false)
            setEmailErrorMsg('')
        }
        if (name === 'contact_number' && value === '') {
            setContactError(true)
            setContactErrorMsg('Field is required')
        } else {
            setContactError(false)
            setContactErrorMsg('')
        }
        if (name === 'contact_number' && value.length < 9) {
            console.log(value.length < 9);
            setContactError(true)
            setContactErrorMsg('Mobile number must be a 9 digit number')
        } else {
            setContactError(false)
            setContactErrorMsg('')
        }
        setUser({...user, [name]: value})
    }

    useEffect(() => {
        let role_based_perm = JSON.parse(localStorage.getItem('role_based_permissions'));
        let direct_perm = JSON.parse(localStorage.getItem('direct_permissions'));
        console.log("role_based: ", role_based_perm);
        console.log("direct perm: ", direct_perm);
        if (role_based_perm === null || role_based_perm === undefined) {
            setAddButton(false);
        } else {
            role_based_perm.map((perm, i) => {
                if (perm.name === 'add agents') {
                    setAddButton(true);
                }
            })
        }
        if (direct_perm === null || direct_perm === undefined) {
            setAddButton(false);
        } else {
            direct_perm.map((perm, i) => {
                if (perm.name === 'add agents') {
                    setAddButton(true);
                }
            })
        }
    }, [])

    return (
        <div>
            {addButton && (
                <Tooltip title="Add New">
                 <span className="btn btn-sm btn-primary mr-5" onClick={handleClickOpen}>
                    <i className="fa fa-plus-square"/> &nbsp;&nbsp;Add Manager
                </span>
                </Tooltip>
            )}
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">Add Manager</DialogTitle>
                <DialogContent>
                    <DialogContentText>Please fill in details</DialogContentText>
                    {error && (
                        <small className="text-danger">Make sure every field is filled in.</small>
                    )}
                    <TextField
                        error={nameError}
                        helperText={nameErrorMsg}
                        required
                        autoFocus
                        margin="dense"
                        label="FirstName"
                        type="text"
                        fullWidth
                        value={user.name}
                        inputProps={{style: {textTransform: 'capitalize'}}}
                        onChange={handleChange('name')}
                    />
                    <TextField
                        error={lastNameError}
                        helperText={lastNameErrorMsg}
                        required
                        margin="dense"
                        label="LastName"
                        type="text"
                        fullWidth
                        value={user.surname}
                        inputProps={{style: {textTransform: 'capitalize'}}}
                        onChange={handleChange('surname')}
                    />

                    <TextField
                        error={emailError}
                        helperText={emailErrorMsg}
                        required
                        margin="dense"
                        label="Email"
                        type="email"
                        fullWidth
                        inputProps={{style: {textTransform: 'lowercase'}}}
                        value={user.email}
                        onChange={handleChange('email')}
                    />
                    <TextField
                        error={contactError}
                        helperText={contactErrorMsg}
                        required
                        margin="dense"
                        label="Contact Number"
                        type="number"
                        fullWidth
                        value={user.contact_number}
                        onChange={handleChange('contact_number')}
                        onInput={(e) => {
                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 9)
                        }}
                        InputProps={{
                            startAdornment: <InputAdornment position="start">
                                +263
                            </InputAdornment>
                        }}
                    />
                    <label>Branch</label>
                    <Select className="form-control" onChange={handleChange('branch')} name="branch">
                        <option disabled={true}>Select Branch</option>
                        <option value='Harare'>Harare</option>
                        <option value='Bulawayo'>Bulawayo</option>
                    </Select>
                    {branchError && (
                        <span className="text-danger">{branchErrorMsg}</span>
                    )}
                </DialogContent>
                <DialogActions>
                    <Tooltip title="Add multiple">
                        <Switch
                            checked={switchState.addMultiple}
                            onChange={handleSwitchChange('addMultiple')}
                            value="addMultiple"
                            inputProps={{'aria-label': 'secondary checkbox'}}
                        />
                    </Tooltip>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleAdd} color="primary">
                        Add
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

AddUserDialog.propTypes = {
    addUserHandler: PropTypes.func.isRequired,
}

export default AddUserDialog;
